import Avatar from "@material-ui/core/Avatar";
import styled from "styled-components";

export const Root = styled(Avatar)`
  ${({ theme }) => `
    padding: ${theme.spacing(1)}px;
  `}
`;
